import { apiStudent } from '@/lib/api-manager'
import type { AvailableCourse } from '@/types/courses/availableCourse'

export async function getAllAvailableCourses(): Promise<AvailableCourse[]> {
  return (await apiStudent.get('v1/educations/integrations/courses')).data.data
}
